import React from "react";
import {connect} from "react-redux";
import List from '../../../components/CRM/List';
import {Datagrid, TextField, BooleanField, DateField} from "admin-on-rest";
import ActionBar from "../../../components/CRM/ActionBar";
import ActionMenu from "../../../components/CRM/ActionMenu";
import {refreshView as refreshViewAction} from "admin-on-rest";


class MarketingPartnerDataListBase extends React.Component {

  render() {
    const props = {...this.props};

    return (
      <List
        title="resources.marketingPartners.name"
        {...props}
        actions={<ActionBar {...props} deleteButton={false} createButton={false}/>}
      >
        <Datagrid>
     
          <TextField
            label="resources.marketingPartners.fields.name"
            source="name"
          />

          <BooleanField
            label="resources.marketingPartners.fields.features.integration"
            source="features.integration"
          />

          <BooleanField
            label="resources.marketingPartners.fields.features.signup_sms"
            source="features.signup_sms"
          />

          <BooleanField
            label="resources.marketingPartners.fields.features.signup_url"
            source="features.signup_url"
          />

          <BooleanField
            label="resources.marketingPartners.fields.features.affiliate_links"
            source="features.affiliate_links"
          />

          <BooleanField
            label="resources.marketingPartners.fields.features.gift_card"
            source="features.gift_card"
          />
     
          <DateField
            label="resources.marketingPartners.fields.createdAt"
            source="created_at"
          />
          <ActionMenu
            deleteButton={false}
            showButton={false}
            editButton={true}
          />
        </Datagrid>
      </List>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    record: state.admin.resources[props.resource]
  };
};

const MarketingPartnerDataList = connect(
  mapStateToProps,
  {
    refreshView: refreshViewAction
  }
)(MarketingPartnerDataListBase);

export default MarketingPartnerDataList;



// WEBPACK FOOTER //
// ./src/containers/CRM/MarketingPartners/MarketingPartnerDataList.js